import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLoginComponent } from './app-login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule} from '@angular/material/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AuthService, AuthServiceActivation } from './auth.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { LinkPromptComponent } from './link-prompt/link-prompt.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [AppLoginComponent, LinkPromptComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatButtonModule,
    MatProgressBarModule,
    AngularFirestoreModule,
    MatTabsModule
  ],
  providers: [
    AuthService,
    AuthServiceActivation
  ]
})
export class AppLoginModule { }
